import { render, staticRenderFns } from "./staffAttendanceReplenishCheckIn.vue?vue&type=template&id=70f45bca&scoped=true"
import script from "./staffAttendanceReplenishCheckIn.vue?vue&type=script&lang=js"
export * from "./staffAttendanceReplenishCheckIn.vue?vue&type=script&lang=js"
import style0 from "./staffAttendanceReplenishCheckIn.vue?vue&type=style&index=0&id=70f45bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f45bca",
  null
  
)

export default component.exports